import React from "react";
import { Card, Button, Spinner, Row } from "react-bootstrap";
import { ProgressBar } from "react-loader-spinner";

const ThumbnailUpload = ({ selectedFile, isUploading, uploadImage }) => {
  uploadImage();
  return (
    <Row className='text-center'>
      <div className='mx-auto'>
        {
          !isUploading && <p>Preparing</p>

          // <Button
          //   className='mt-3 mb-4 text-center'
          //   variant='primary'
          //   onClick={uploadImage}>
          //   Click to Upload!{" "}
          //   {selectedFile ? selectedFile.name : "Please Press Upload"}
          // </Button>
        }

        {isUploading && (
          <>
            <ProgressBar
              height='80'
              width='280'
              ariaLabel='progress-bar-loading'
              wrapperStyle={{}}
              wrapperClass='progress-bar-wrapper'
              borderColor='#F4442E'
              barColor='#f5b725'
            />
            <p>Uploading..</p>
          </>
        )}
      </div>

      {/* <div>
        <img
          src={URL.createObjectURL(selectedFile)}
          alt='Selected File Thumbnail'
          style={{ height: "auto", width: "400px" }}
          className='mb-4, mt-2 text-center'
        />
      </div> */}
    </Row>
  );
};

export default ThumbnailUpload;
